import React from 'react';
import { ConfirmationDialog } from './ConfirmationDialog';
import { Trash01 } from '../../../assets';
import { useTranslation } from 'react-i18next';

interface ConfirmationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  nameOfObject: string;
}

export const ConfirmationDeleteDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onConfirm,
  onCancel,
  nameOfObject,
}) => {
  const { t } = useTranslation('common');

  return (
    <ConfirmationDialog open={open}
      message={t('deleteModalMessage')}
      onConfirm={onConfirm}
      onCancel={onCancel}
      icon={<Trash01 />}
      title={t('deleteObject', { nameOfObject })}
      variant='bad'
      confirmButtonText={t('delete')}
      cancelButtonText={t('cancel')}
    />
  );
};
